import { RoleCapacity } from '@ng-gems/api';

/**
 * Model for API AccessControlCapacity Model
 */
export class AccessControlCapacity {
  /**
   * Name of the capacity
   * example: api.users.roles.read
   */
  name: RoleCapacity;

  /**
   * Description of the capacity in the requested language
   */
  description: string;

  constructor(attributes: Partial<AccessControlCapacity> = {}) {
    Object.assign(this, attributes);
  }

  equalTo(capacity: AccessControlCapacity): boolean {
    return this.name === capacity.name;
  }
}
